import { TimeOfDay } from '../types/TimeOfDay';

export const SIDEBAR_CONTENT_MAX_WIDTH = 500;

export const getTimeOfDay = (): TimeOfDay => {
    // time in the user's timezone
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
        return TimeOfDay.MORNING;
    } else if (currentHour >= 12 && currentHour < 18) {
        return TimeOfDay.AFTERNOON;
    } else {
        return TimeOfDay.EVENING;
    }
};
